import { render, staticRenderFns } from "./ScienceTenchnology.vue?vue&type=template&id=01bfde38&scoped=true"
import script from "./ScienceTenchnology.vue?vue&type=script&lang=js"
export * from "./ScienceTenchnology.vue?vue&type=script&lang=js"
import style0 from "./ScienceTenchnology.vue?vue&type=style&index=0&id=01bfde38&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bfde38",
  null
  
)

export default component.exports